import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import { setEventCategory } from "../../utils/setEventCategory";
export var sendToggleModalEvent = function sendToggleModalEvent(isOpen, placement) {
  return sendGAEvent({
    event: 'custom_event',
    event_action: 'Change currency/location click',
    event_category: setEventCategory(placement),
    event_label: "".concat(isOpen ? 'open' : 'close', " modal")
  });
};